<woa-modal-page-layout [title]="title()" [translationParams]="instructionParams()">
    <woa-tip-selection-panel class="tip-selection"
                             [(tipAmount)]="tipAmount" [(tipSelected)]="tipSelected"
                             (tipSelectedChange)="applyTip(false)"></woa-tip-selection-panel>
    @if (this.sessionModel.orderingPhase() === OrderingPhase.PAYMENT) {
        <woa-button woa-page-footer-control
                    [label]="'woa.button.tip.confirmAndPay'"
                    [translationParams]="{'amount': ((orderModel.orderTotal() + tipAmount()) | woaCurrency)}"
                    (onActivate)="applyTip(true)"></woa-button>
    }
</woa-modal-page-layout>
